import React from 'react';
import { Button } from '@mui/material';
import { ReactComponent as IconChange } from '../../../assets/icons/IconChange.svg';
import { ReactComponent as IconDelete } from '../../../assets/icons/IconDelete.svg';
import { DropzoneRootProps } from 'react-dropzone';

interface ProfilePicturePreviewProps {
  file?: { preview: string };
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  onRemoveFile?: () => void;
}

const ProfilePicturePreview: React.FC<ProfilePicturePreviewProps> = ({
  file,
  getRootProps,
  onRemoveFile,
}) => (
  <div className="containerUrlPicture">
    <img className="profilePicture" src={file?.preview} alt="pré visualização da foto" />
    <div className="containerButton">
      <Button {...getRootProps()} aria-label="Trocar foto">
        <IconChange /> Trocar foto
      </Button>
      <Button onClick={() => onRemoveFile?.()} aria-label="Excluir foto">
        <IconDelete /> Excluir foto
      </Button>
    </div>
  </div>
);

export default ProfilePicturePreview;
